import React from 'react'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setMenuOpen } from '@store/features/navigation/navigationSlice'
import { X, Smartphone, Shield, CreditCard, Gift, Store, Phone } from 'lucide-react'

interface SidebarProps {
  isOpen: boolean
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen }) => {
  const dispatch = useDispatch()

  const navigationItems = [
    { name: '首页', path: '/', icon: Smartphone },
    { name: '产品', path: '/products', icon: Smartphone },
    { name: '解决方案', path: '/solutions', icon: Shield },
    { name: '关于我们', path: '/about', icon: Smartphone },
    { name: '新闻中心', path: '/news', icon: Smartphone },
    { name: '投资合作', path: '/investment', icon: CreditCard },
    { name: '人才招聘', path: '/careers', icon: Gift },
    { name: '联系我们', path: '/contact', icon: Phone },
  ]

  const productItems = [
    { name: 'CoreTrust手机', path: '/products/coretrust' },
    { name: '熄屏广告系统', path: '/products/ads' },
    { name: '空投助手', path: '/products/airdrop' },
    { name: '数字银行', path: '/products/bank' },
    { name: '硬件钱包', path: '/products/wallet' },
    { name: '应用市场', path: '/products/market' },
    { name: '去中心化通话', path: '/products/call' },
  ]

  const handleLinkClick = () => {
    dispatch(setMenuOpen(false))
  }

  return (
    <>
      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => dispatch(setMenuOpen(false))}
        />
      )}

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full w-80 bg-white dark:bg-gray-900 shadow-xl transform transition-transform duration-300 ease-in-out z-50 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="p-6">
          {/* Header */}
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <Smartphone className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold text-gray-900 dark:text-white">
                DeepLink
              </span>
            </div>
            <button
              onClick={() => dispatch(setMenuOpen(false))}
              className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800"
            >
              <X className="w-5 h-5 text-gray-700 dark:text-gray-300" />
            </button>
          </div>

          {/* Navigation */}
          <nav className="space-y-2">
            {navigationItems.map((item) => {
              const Icon = item.icon
              return (
                <div key={item.name}>
                  <Link
                    to={item.path}
                    onClick={handleLinkClick}
                    className="flex items-center space-x-3 px-4 py-3 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors duration-200"
                  >
                    <Icon className="w-5 h-5" />
                    <span>{item.name}</span>
                  </Link>
                  
                  {/* Product Submenu */}
                  {item.name === '产品' && (
                    <div className="ml-8 mt-2 space-y-1">
                      {productItems.map((subItem) => (
                        <Link
                          key={subItem.name}
                          to={subItem.path}
                          onClick={handleLinkClick}
                          className="block px-4 py-2 text-sm text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-50 dark:hover:bg-gray-800 rounded-lg transition-colors duration-200"
                        >
                          {subItem.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              )
            })}
          </nav>

          {/* Footer */}
          <div className="absolute bottom-6 left-6 right-6">
            <div className="text-center text-sm text-gray-500 dark:text-gray-400">
              <p>转账别害怕，地址打电话</p>
              <p className="mt-1">© 2024 DeepLink Limited</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Sidebar